import { Pipe, PipeTransform } from '@angular/core';
import { LANGUAGE_LEVEL } from '@app/config/language';

@Pipe({
  name: 'languageLevelName'
})
export class LanguageLevelNamePipe implements PipeTransform {

  transform(value: number): string {

    const element = LANGUAGE_LEVEL.find(e => +e.id === +value);

    return element != undefined ?  element.name : ''
  }
}
